import React from 'react';

export const I18nTranslateContext = React.createContext();
export const I18nLanguageContext = React.createContext();
